(function () {
  'use strict';

  var LOADER_SELECTOR = '[data-one-luxury-immersive-orbit-loader]';
  var SECTION_SELECTOR = '[data-one-luxury-immersive-orbit]';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var runtimePromise = window.__ONE_LUXURY_IMMERSIVE_ORBIT_RUNTIME_PROMISE__;
  var pendingSection = null;
  var intersectionObserver = null;
  var idleHandle = null;
  var fallbackTimer = null;

  function setPosterState(section, state) {
    section.setAttribute('data-immersive-runtime-state', state);
    if (state !== 'reduced-motion') return;
    var status = section.querySelector('[data-immersive-status]');
    if (status) status.textContent = section.getAttribute('data-status-fallback') || '';
  }

  function injectRuntime(loader) {
    if (runtimePromise) return runtimePromise;

    runtimePromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-one-luxury-immersive-orbit-runtime]');
      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = loader.getAttribute('data-runtime-src');
      script.async = true;
      script.setAttribute('data-one-luxury-immersive-orbit-runtime', '');
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    window.__ONE_LUXURY_IMMERSIVE_ORBIT_RUNTIME_PROMISE__ = runtimePromise;
    return runtimePromise;
  }

  function cancelScheduledBoot() {
    if (idleHandle !== null && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(idleHandle);
    }
    if (fallbackTimer !== null) window.clearTimeout(fallbackTimer);
    idleHandle = null;
    fallbackTimer = null;
  }

  function boot(section) {
    if (!section || runtimePromise || reducedMotion.matches || document.hidden) return;
    cancelScheduledBoot();
    var loader = document.querySelector(LOADER_SELECTOR);
    if (!loader || !loader.getAttribute('data-runtime-src')) return;
    setPosterState(section, 'loading');
    injectRuntime(loader).catch(function () {
      setPosterState(section, 'fallback');
    });
  }

  function scheduleBoot(section) {
    if (!section || runtimePromise || reducedMotion.matches || document.hidden) return;
    pendingSection = section;
    if (idleHandle !== null || fallbackTimer !== null) return;

    var queue = function () {
      if ('requestIdleCallback' in window) {
        idleHandle = window.requestIdleCallback(function () {
          idleHandle = null;
          boot(section);
        }, { timeout: 1800 });
      } else {
        fallbackTimer = window.setTimeout(function () {
          fallbackTimer = null;
          boot(section);
        }, 900);
      }
    };

    if (document.readyState === 'complete') queue();
    else window.addEventListener('load', queue, { once: true });
  }

  function observe(section) {
    if (!section) return;
    pendingSection = section;
    if (reducedMotion.matches) {
      setPosterState(section, 'reduced-motion');
      return;
    }

    // IntersectionObserver delivery can be delayed by authenticated Shopify
    // previews. Start the controlled idle boot immediately when the hero is
    // already in or near the initial viewport, while retaining observation for
    // sections that begin offscreen.
    var rect = section.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top <= viewportHeight + 160 && rect.bottom >= -160) {
      scheduleBoot(section);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      scheduleBoot(section);
      return;
    }

    if (intersectionObserver) intersectionObserver.disconnect();
    intersectionObserver = new IntersectionObserver(function (entries, observer) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      intersectionObserver = null;
      scheduleBoot(section);
    }, { rootMargin: '160px 0px' });
    intersectionObserver.observe(section);
  }

  function handleVisibility() {
    if (document.hidden) {
      cancelScheduledBoot();
      return;
    }
    if (pendingSection && !runtimePromise) observe(pendingSection);
  }

  function handleMotionChange() {
    cancelScheduledBoot();
    if (!pendingSection || runtimePromise) return;
    observe(pendingSection);
  }

  document.addEventListener('visibilitychange', handleVisibility);
  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', handleMotionChange);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(handleMotionChange);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);
    if (section && !runtimePromise) observe(section);
  });

  observe(document.querySelector(SECTION_SELECTOR));
})();
